import axios from 'axios'
import qs from 'qs'
import moment from 'moment'
import {
  MessageBox,
  Message
} from 'element-ui'
import store from '@/store'
import tokenStorage from '@/utils/storage/tokenStorage'

import {
  Loading
} from 'element-ui';
import router from '@/router'
let loading = null;
const service = axios.create({
  baseURL: process.env.VUE_APP_Monitor_Api,
  //withCredentials: true, // 跨域请求时发送 cookies
  // timeout: 5000 // request timeout
  timeout: '5000',
  responseType: "json",

})

// request interceptor
service.interceptors.request.use(
  config => {
    store.dispatch('app/aSetRequestCount', ++store.state.app.requestCount)
    if (!config.hideLoading) {
      loading = Loading.service({
        fullscreen: true,
        text: '加载中。。。',
        customClass: 'loadStyle',
        background: 'rgba(51, 51, 51, 0.8)'
      });
    }
    if (config.contentType == 'form') {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    } else if (config.contentType == 'json') {
      config.headers['Content-Type'] = 'application/json';
    }
    config.timeout = config.headers['Content-Type'] === "multipart/form-data" ? '7200000' : '7200000'
    //转换日期格式，避免自动转换成时区问题
    if (config.method === 'post') {
      if (config.data)
        Object.keys(config.data).forEach(key => {
          if (toString.call(config.data[key]) === '[object Date]' && config.data[key]) {
            config.data[key] = moment(config.data[key]).format('YYYY-MM-DD HH:mm:ss')
          }
        });
    } else {
      if (config.params)
        Object.keys(config.params).forEach(key => {
          if (toString.call(config.params[key]) === '[object Date]' && config.params[key]) {
            config.params[key] = moment(config.params[key]).format('YYYY-MM-DD HH:mm:ss')
          }
        });
    }
    //统一格式化数据
    if (config.method === 'post' && config.stringify) {

      config.data = qs.stringify({
        ...config.data // 将参数变成  a=xx&b=xx&c=xx这样的参数列表
      });
    }
    if (store.getters.token) {
      if(config.isdeletetoken){
      }
      else{
        // 让每个请求携带token
        config.headers['usertoken'] = tokenStorage.getToken()
        config.headers['Authorization'] = tokenStorage.getToken()
      }
    }
    //菜单ID
    if (config.noModuleID) {
      config.headers['ModuleId'] = ''
    } else {
      config.headers['ModuleId'] = store.state.permission.moduleID
    }
    config.headers['ClientType'] = 1
    //待处理
    config.headers['ClientIp'] = store.state.app.clientIp
    return config
  },
  error => {
    Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    store.dispatch('app/aSetRequestCount', --store.state.app.requestCount)
    // console.log(router.currentRoute.path);
    if (store.state.app.requestCount <= 0) {
      loading.close();
    }
    //const res = response.data
    let res = {};
    if (response.config.url.indexOf('DrillHole/ImportPointSurveyRecordData') != -1 ||response.config.url.indexOf('DrillHole/ImportTemperatureRecord') != -1 ||response.config.url.indexOf('GCProjectWeek/WeekDataExport') != -1 || response.config.url.indexOf('ProjectInitiation/DataEcharExport') != -1 || response.config.url.indexOf('ProjectChange/generatepdf') != -1 || response.config.url.indexOf('ProjectAcceptance/DataExport') != -1 || response.config.url.indexOf('document/download') != -1 || response.config.url.indexOf("CloudDiskUpload/downFile") != -1 || response.config.url.indexOf("ProjectInitiation/getProjectPDF") != -1 || response.config.url.indexOf("KJGLContract/getContractPDF") != -1 || response.config.url.indexOf("ProjectInitiation/DataExport") != -1 || response.config.url.indexOf("KJGLContract/DataExport") != -1 || response.config.url.indexOf("KJGLContract/getGroupContractPDF") != -1 || response.config.url.indexOf("KJGLContract/getGroupTaskPDF") != -1) {
      res = response
    } else {
      res = response.data
    }
    //业务接口
    if (res.Code) {
      //toke异常重新登录
      if (res.Code === 401) {
        MessageBox.alert('用户失效，请重新登录', '警告', {
          confirmButtonText: '重新登录',
          callback: action => {
            store.dispatch('user/resetToken').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          }
        });
      } else if (res.Code === 10004) {
        store.dispatch('user/resetToken').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      } else if (res.Code === 10000) {
        Message({
          message: res.Message,
          type: 'error',
          duration: 2 * 1000
        })
        router.push({
          path: '/register',
          query: {
            code: res.Data
          }
        })
      } else {
        if (response.config.notShowMsg) {
          return res
        }
        //除200以外，所有的都消息提示
        if (res.Code !== 200) {
          let messageType = 'error'
          if (res.Code === 10002)
            messageType = 'warning'
          Message({
            message: res.Message,
            type: messageType,
            duration: 2 * 1000
          })
        }
        return res
      }
    }
    //平台接口
    else {
      return res
    }
  },
  error => {
    store.dispatch('app/aSetRequestCount', --store.state.app.requestCount)
    if (store.state.app.requestCount <= 0) {
      loading.close();
    }
    if (error.message.indexOf('401') != -1) {

      MessageBox.alert('用户失效，请重新登录', '警告', {
        confirmButtonText: '重新登录',
        callback: action => {
          // store.dispatch('user/resetToken').then(() => {
          //   location.reload() // 为了重新实例化vue-router对象 避免bug
          // })
           router.push({ path: '/login'})
        }
      });
    } else if (error.message.indexOf('10004') != -1) {
      store.dispatch('user/resetToken').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    } else {
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js